import { USER_LANGUAGES } from '../assets/AppConstants';

const getLanguageByName = (name) => USER_LANGUAGES.find((lang) => (
  lang.name.toLocaleLowerCase() === name.toLocaleLowerCase()
));

export const getLanguageById = (id) => USER_LANGUAGES.find((lang) => (
  lang.id.toLocaleLowerCase() === id.toLocaleLowerCase()
));

export const getDefaultLanguage = () => {
  const browserLang = navigator.language.substring(0, 2);
  const language = getLanguageByName(browserLang);

  return language || USER_LANGUAGES[0];
};
